/**
 * Kantera Web Dashboard
 * React + Vite application
 */

import { initWebSentry } from './sentry';

// Sentry must be the very first thing initialised so its instrumentation hooks
// are in place before React or any other library mounts.
initWebSentry();

// Initialize i18n before rendering any components
import { initI18n } from '@kantera/ui';
initI18n('en');

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { installChunkReloadHandler } from './utils/chunkReload';
import './index.css';

// A deploy renames every lazy chunk. A tab still holding the old index.html
// then fails to fetch a route it has never loaded; Vite raises
// `vite:preloadError` for a chunk's preloaded dependencies. One guarded reload
// (per path, per 10 s — see utils/chunkReload.ts) picks up the new build.
// The lazy() import itself rejecting is handled by the ErrorBoundary.
installChunkReloadHandler(window);

const root = document.getElementById('root');

if (!root) {
  throw new Error('Root element not found');
}

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
